import { render, staticRenderFns } from "./persionListItem.vue?vue&type=template&id=07125eae&scoped=true"
import script from "./persionListItem.vue?vue&type=script&lang=js"
export * from "./persionListItem.vue?vue&type=script&lang=js"
import style0 from "./persionListItem.vue?vue&type=style&index=0&id=07125eae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07125eae",
  null
  
)

export default component.exports